const filterTags = [
  "ALL",
  "VALIDATE",
  "VALUE",
  "INSIGHT",
  "IDEATE",
  "BUILD",
  "ANALYZE",
  "METHODS",
  "CULTURE",
];

const mobiusLoopArray = [
  "All",
  "Discovery",
  "Options",
  "Delivery",
  "Foundation",
];

export { filterTags, mobiusLoopArray };
